<section class="login-tabs__panel">

    @if(otpStep() === 'emailInput') {


    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
        <div class="field">
            <label class="label has-text-black">{{ 'pages.login.email' | translate }}</label>
            <div class="control has-icons-left">
                <input class="input is-rounded" type="email" placeholder="you@company.com" formControlName="email">
                <span class="icon is-small is-left">
                    <i class="ri-mail-line"></i>
                </span>
            </div>
            @if(emailForm.get('email')?.invalid && emailForm.get('email')?.touched) {
            <p class="help is-danger">{{ 'pages.login.invalidEmail' | translate }}</p>
            }
        </div>

        @if(showError()) {
        <div class="notification is-danger is-light">
            {{'pages.login.otpError' | translate }}
        </div>
        }

        <div class="field mt-4">
            <div class="control">
                <button class="button is-primary is-rounded is-fullwidth" [class.is-loading]="isInSubmit()">
                    {{ 'pages.login.sendCode' | translate }}
                </button>
            </div>
        </div>
    </form>
    } @else if(otpStep() === 'enterOtp') {

    @if(!showError()) {
    <div class="notification is-primary is-light has-text-size-small mb-4">
        {{ 'pages.login.otpHasBeenSent' | translate }}
    </div>
    }

    <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
        <div class="field mt-4">
            <label class="label has-text-black">{{ 'pages.login.enterCode' | translate }}</label>
            <div class="control">
                <input class="input is-rounded" type="text" placeholder="123 456" formControlName="otp">
            </div>
            <p class="help">
                {{ 'pages.login.otpExpiration' | translate }}
            </p>
        </div>

        @if(showError()) {
        <div class="notification is-danger is-light">
            {{'pages.login.otpInvalid' | translate }}
        </div>
        }

        <div class="field mt-4">
            <div class="control">
                <button class="button is-primary is-rounded is-fullwidth">
                    {{ 'pages.login.verifyCode' | translate }}
                </button>
            </div>
        </div>
    </form>
    }


</section>